import * as type from "../../types/API/stockTransfer";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const stockTransferReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.STOCK_TRANSFER:
      return {
        ...state,
        loading: true,
      };
    case type.STOCK_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.STOCK_TRANSFER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getAllRejectStoreItemsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_ALL_REJECT_STORE_ITEMS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ALL_REJECT_STORE_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData?.data,
      };
    case type.GET_ALL_REJECT_STORE_ITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};